// Compute a padded axis range across one or more lists of raw values.
// Used to give a group of charts one shared scale instead of each
// autoscaling independently to its own data.
export function computeAxisRange(
  valueLists: number[][],
  options?: { includeZero?: boolean },
): [number, number] {
  let min = Infinity;
  let max = -Infinity;
  valueLists.forEach((values) => {
    values.forEach((v) => {
      if (v != null && isFinite(v)) {
        min = Math.min(min, v);
        max = Math.max(max, v);
      }
    });
  });

  if (options?.includeZero && min >= 0) {
    min = -2;
  }

  const range = max - min;
  const padding = range * 0.1;
  return [min - padding, max + padding];
}
